// * Single time actions during initialization.
export const INITIALIZE = "INITIALIZE";
export const SET_INITIAL_ACTIVE_FILTERS = "SET_INITIAL_ACTIVE_FILTERS";
export const SET_ACTIVE_FILTER_ID = "SET_ACTIVE_FILTER_ID";

// * Actions that are fetching data from the API.
// ** Main facets
export const FETCH_MAIN_FACETS = "FETCH_MAIN_FACETS";
export const MAIN_FACETS_ERROR = "MAIN_FACETS_ERROR";
export const UPDATE_MAIN_FACETS_COUNT = "UPDATE_MAIN_FACETS_COUNT";
// ** Facets
export const FETCH_FACETS = "FETCH_FACETS";
// ** Middlefacets
export const FETCH_MIDDLEFACETS = "FETCH_MIDDLEFACETS";
// ** Results
export const SHOW_RESULTS = "SHOW_RESULTS";
export const SET_RESULTS_ERROR = "SET_RESULTS_ERROR";
export const UNSET_RESULTS_ERROR = "UNSET_RESULTS_ERROR";

// * Facets actions: Affect the search results.
export const ACTIVATE_MAIN_FACET = "ACTIVATE_MAIN_FACET";
export const ACTIVATE_FACET = "ACTIVATE_FACET";
export const ACTIVATE_FACET_MULTI = "ACTIVATE_FACET_MULTI";
export const DEACTIVATE_FACET = "DEACTIVATE_FACET";
export const DEACTIVATE_FACET_MULTI = "DEACTIVATE_FACET_MULTI";
    // This is used when a hovedfasett or a middlefacet is removed from the active filters, so their child facets are
    // expected to be deactivated also.
export const DEACTIVATE_DEPENDENT_FACETS = "DEACTIVATE_DEPENDENT_FACETS";

// * UI related actions.
// ** Groups.
export const ACTIVATE_GROUP = "ACTIVATE_GROUP";
export const CLEAR_ACTIVE_GROUP = "CLEAR_ACTIVE_GROUP";
export const ACTIVATE_GROUP_WITH_MIDDLEFACETS = "ACTIVATE_GROUP_WITH_MIDDLEFACETS";
export const DEACTIVATE_GROUP_WITH_MIDDLEFACETS = "DEACTIVATE_GROUP_WITH_MIDDLEFACETS";
export const ADD_TO_AVAILABLE_GROUPS = "ADD_TO_AVAILABLE_GROUPS";
export const REMOVE_FROM_AVAILABLE_GROUPS = "REMOVE_FROM_AVAILABLE_GROUPS";
export const RESET_AVAILABLE_GROUPS = "RESET_AVAILABLE_GROUPS";
// ** Facets menu.
export const SHOW_MENU = "SHOW_MENU";
export const HIDE_MENU = "HIDE_MENU";
export const TOGGLE_MENU = "TOGGLE_MENU";

// * Autocomplete search related actions.
export const SET_SEARCH_VALUE = "SET_SEARCH_VALUE";
export const FETCH_AUTOCOMPLETE_RESULTS = "FETCH_AUTOCOMPLETE_RESULTS";
export const UNSET_SEARCH_VALUE = "UNSET_SEARCH_VALUE";
export const SUBMIT_SEARCH_VALUE = "SUBMIT_SEARCH_VALUE";
export const CLOSE_OVERLAY = "CLOSE_OVERLAY";
export const OPEN_OVERLAY = "OPEN_OVERLAY";
export const SET_KEYBOARD_POSITION = "SET_KEYBOARD_POSITION";

// * Other actions.
export const RESET_SEARCH = "RESET_SEARCH";
export const GOTO_PAGE = "GOTO_PAGE";
export const SET_MOBILE = "SET_MOBILE";
export const CACHE_RESPONSE = "CACHE_RESPONSE";